export default __webpack_public_path__ + "static/3p8-workflow-step-f4e7becc8c594da3a4c98b113c1c9869.png";